export const environment = {
  production: true,
  backendUrl: 'https://csem.difesa.it/genomica/api',
  betterResourceUrl: 'https://csem.difesa.it/ehr/rest/v1',
  keycloak: {
    url: 'https://csem.difesa.it/iam/',
    realm: 'fascicolo_sanitario',
    clientId: 'medical_care_front',
    redirectUrl: window.location.origin + '/care-plan/assets/silent-check-sso.html'
  },
  pharmaKgb:'https://api.pharmgkb.org/v1/',
  forms: {
    drugsName: 'Allergie e Medicazioni',
    drugsVersion: '1.0.255',
    alertsName: 'Allerts',
    alertsVersion: '1.0.168',
    consentName: 'Consenso e gestione del piano',
    consentVersion: '1.0.125',
    contactsName: 'Contatti personali e professionali',
    contactsVersion: '1.0.379',
    cprTreatmentName: "Decisione sulla CPR e sull'escalation del trattamento",
    cprTreatmentVersion: '1.0.640',
    personalDataName: 'Informazioni personali',
    personalDataVersion: '1.0.399',
    prognosisName: 'Informazioni sulla salute e prognosi',
    prognosisVersion: '1.0.314',
    symptomsName: 'Piano di gestione dei sintomi',
    symptomsVersion: '1.0.179',
    statsNameMilitary: 'Dati',
    statsVersionMilitary: '1.0.23',
    statsNameCivilian: 'DatiCivilian',
    statsVersionCivilian: '1.0.27',
  }
};
